import React from 'react';
import { Info } from 'lucide-react';

// Beta — aviso uniforme cuando una función de IA está apagada para esta sesión
// (ver hooks/useCapacidadesIA.js). Siempre ofrece la alternativa manual si existe.
export default function AvisoIANoDisponible({ children }) {
  return (
    <div role="status" data-testid="aviso-ia-no-disponible" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '12px 14px', borderRadius: '10px', background: 'rgba(255,182,92,.1)', border: '1px solid rgba(255,182,92,.4)', fontSize: '12.5px', lineHeight: 1.5, color: 'var(--text, #F5F6FA)' }}>
      <Info size={16} color="#FFB65C" style={{ flexShrink: 0, marginTop: '1px' }} />
      <span>{children}</span>
    </div>
  );
}
